<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-col cols="" class="pa-0 list-title" v-on="on" v-bind="attrs">
        {{ cqa.cqaTitle }}
      </v-col>
    </template>
    <v-card class="modal-pop modal-type-01">
      <v-card-title class="modal-title">{{ $t('Q&A 문의하기') }}</v-card-title>
      <vue-custom-scrollbar class="modal-scroll">
        <v-card-text class="modal-contents">
          <v-row class="ma-0">
            <v-col class="pa-0">
              <v-row class="ma-0 mb-2" v-if="cqa.cqaAnnoTitle">
                <i-text-field
                  v-model="cqa.cqaAnnoTitle"
                  label="공고"
                  outlined
                  hide-details
                  dense
                  class="box-type-01"
                  readonly=""
                ></i-text-field>
              </v-row>
              <v-row class="ma-0 mb-2">
                <i-text-field
                  v-model="cqa.cqaCategory"
                  label="질문구분"
                  outlined
                  hide-details
                  dense
                  class="box-type-01"
                  readonly=""
                ></i-text-field>
              </v-row>
              <v-row class="ma-0 mb-2">
                <i-text-field
                  v-model="cqa.cqaTitle"
                  label="제목"
                  outlined
                  hide-details
                  dense
                  class="box-type-01"
                  readonly=""
                ></i-text-field>
              </v-row>
              <v-row class="ma-0 mb-2">
                <i-textarea
                  v-model="cqa.cqaContent"
                  label="내용"
                  outlined
                  hide-details
                  dense
                  no-resize
                  class="box-type-textarea"
                  readonly=""
                ></i-textarea>
              </v-row>
              <v-row class="ma-0 mb-2">
                <i-textarea
                  v-model="cqa.cqaReplyContent"
                  label="답변내용"
                  outlined
                  hide-details
                  dense
                  no-resize
                  class="box-type-textarea"
                  readonly=""
                ></i-textarea>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </vue-custom-scrollbar>
      <v-card-actions class="modal-btn">
        <i-btn class="btn-type-01" @click="dialog = false">
          닫기
        </i-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DialogMixin } from '@/mixin/dialog.js';

import vueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';

export default {
  components: { vueCustomScrollbar },
  mixins: [DialogMixin],
  props: {
    cqa: Object,
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
